import axios from 'axios';
import { encryptPayload, normalizeEncryptedApiResponse, plainObjectFromFormData } from './customerCrypto';
import { getCompanySettings, resolveCustomerApiEncrypt } from './companySettingsCache';

export async function postGetSupplierList(fullUrl, jwtToken, { draw, start, length, searchValue }) {
  const settings = await getCompanySettings();
  const useEncrypt = resolveCustomerApiEncrypt(settings);
  const payload = {
    draw,
    start,
    length,
    search: { value: searchValue ?? '', regex: 'false' },
    searchValue: searchValue ?? '',
  };
  let body;
  if (useEncrypt) {
    const ep = encryptPayload(payload);
    if (!ep) {
      return {};
    }
    const fd = new FormData();
    fd.append('encrypted_payload', ep);
    body = fd;
  } else {
    const fd = new FormData();
    fd.append('draw', String(draw));
    fd.append('start', String(start));
    fd.append('length', String(length));
    fd.append('search[value]', String(payload.search.value));
    fd.append('search[regex]', payload.search.regex);
    fd.append('searchValue', String(payload.searchValue));
    body = fd;
  }
  const response = await fetch(fullUrl, {
    method: 'POST',
    headers: { authorization: `Bearer ${jwtToken}` },
    body,
  });
  const raw = await response.json();
  return normalizeEncryptedApiResponse(raw, useEncrypt);
}

export async function postEditSupplier(fullUrl, jwtToken, id) {
  const settings = await getCompanySettings();
  const useEncrypt = resolveCustomerApiEncrypt(settings);
  const fd = new FormData();
  fd.append('id', String(id));
  if (useEncrypt) {
    const ep = encryptPayload({ id: String(id) });
    if (ep) {
      fd.append('encrypted_payload', ep);
    }
  }
  const response = await fetch(fullUrl, {
    method: 'POST',
    headers: { authorization: `Bearer ${jwtToken}` },
    body: fd,
  });
  const raw = await response.json();
  return normalizeEncryptedApiResponse(raw, useEncrypt);
}

export async function axiosPostSupplierMultipart(url, bearerToken, formData) {
  const settings = await getCompanySettings();
  const useEncrypt = resolveCustomerApiEncrypt(settings);
  let body;
  if (useEncrypt) {
    const plain = plainObjectFromFormData(formData);
    const ep = encryptPayload(plain);
    if (!ep) {
      throw new Error('ENCRYPT_KEY_MISSING');
    }
    body = new FormData();
    body.append('encrypted_payload', ep);
  } else {
    body = formData;
  }
  const res = await axios.post(url, body, {
    headers: { authorization: `Bearer ${bearerToken}` },
  });
  return normalizeEncryptedApiResponse(res.data, useEncrypt);
}
